module.exports = __webpack_public_path__ + "img/Weapon_06.3f5899d7.png";